import React from 'react';
import { Redirect} from 'react-router-dom';

export class Refresh extends React.Component {

  constructor(props) {
    super(props);
    this.state = this.props.location.state;
  }

  render() {
    return(
      <Redirect to={this.state.redirectTo} />
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/refresh.js